import { BACCARAT_BET_TYPES as BET_TYPES } from '@ezugi/constants';

import {
  BANKER_WINS_WITH_SIX,
  BANKER_WINS_WITH_SEVEN,
  NATURAL_WIN,
  NATURAL_TIE,
  NON_NATURAL_WIN_BY_NINE_POINTS,
  NON_NATURAL_WIN_BY_EIGHT_POINTS,
  NON_NATURAL_WIN_BY_SIX_SEVEN_POINTS,
  NON_NATURAL_WIN_BY_FOUR_FIVE_POINTS,
} from './strings';

export const PAYOUTS: Record<string, number> = {
  [BET_TYPES.PLAYER]: 1,
  [BET_TYPES.TIE]: 8,
  [BET_TYPES.BANKER]: 0.95,
  [BET_TYPES.PLAYER_PAIR]: 11,
  [BET_TYPES.BANKER_PAIR]: 11,
  [BET_TYPES.PERFECT_PAIR]: 25,
  [BET_TYPES.EITHER_PAIR]: 5,
  [BET_TYPES.SMALL]: 1.5,
  [BET_TYPES.BIG]: 0.54,
  [BET_TYPES.PLAYER_OVER]: 1.6,
  [BET_TYPES.PLAYER_UNDER]: 3.2,
  [BET_TYPES.BANKER_OVER]: 2.5,
  [BET_TYPES.BANKER_UNDER]: 2.5,
} as const;

export const SUPER_SIX_PAYOUTS: Record<string, number> = {
  [BET_TYPES.PLAYER]: 1,
  [BET_TYPES.TIE]: 8,
  [BET_TYPES.BANKER]: 1,
  [BET_TYPES.SUPER_SIX]: 12,
  [BANKER_WINS_WITH_SIX]: 0.5,
} as const;

export const DRAGON_BONUS_PAYOUTS: Record<string, number> = {
  [BET_TYPES.PLAYER]: 1,
  [BET_TYPES.TIE]: 8,
  [BET_TYPES.BANKER]: 0.95,
  [NATURAL_WIN]: 1,
  // 0 value indicates Push
  [NATURAL_TIE]: 0,
  [NON_NATURAL_WIN_BY_NINE_POINTS]: 30,
  [NON_NATURAL_WIN_BY_EIGHT_POINTS]: 10,
  [NON_NATURAL_WIN_BY_SIX_SEVEN_POINTS]: 4,
  [NON_NATURAL_WIN_BY_FOUR_FIVE_POINTS]: 2,
} as const;

export const KNOCKOUT_PAYOUTS: Record<string, number> = {
  [BET_TYPES.PLAYER]: 1,
  [BET_TYPES.TIE]: 8,
  [BET_TYPES.BANKER]: 0.95,
  [NATURAL_TIE]: 0,
  [NATURAL_WIN]: 4,
  [BET_TYPES.NATURAL_PLAYER]: 4,
  [BET_TYPES.NATURAL_BANKER]: 4,
  [BET_TYPES.TOTALS_1_TO_4]: 8,
  [BET_TYPES.TOTALS_5_TO_6]: 4,
  [BET_TYPES.TOTALS_7]: 5,
  [BET_TYPES.TOTALS_8]: 3.3,
  [BET_TYPES.TOTALS_9]: 3,
} as const;

export const DRAGON_TIGER_PAYOUTS: Record<string, number> = {
  [BET_TYPES.DRAGON]: 1,
  [BET_TYPES.TIGER]: 1,
  [BET_TYPES.TIE]: 11,
  [BET_TYPES.SUITED_TIE]: 50,
} as const;

export const NO_COMISSION_PAYOUTS: Record<string, number> = {
  ...PAYOUTS,
  [BET_TYPES.BANKER]: 1,
  [BET_TYPES.SUPER_SIX]: 12,
  [BANKER_WINS_WITH_SIX]: 0.5,
} as const;

export const CRICKET_WAR_PAYOUTS: Record<string, number> = {
  [BET_TYPES.BOWLER]: 1,
  [BET_TYPES.BATSMAN]: 1,
  [BET_TYPES.TIE]: 11,
  [BET_TYPES.SUITED_TIE]: 50,
} as const;

export const EZ_BACCARAT_PAYOUTS = {
  [BET_TYPES.PLAYER]: 1,
  [BET_TYPES.TIE]: 8,
  [BET_TYPES.BANKER]: 1,
  [BET_TYPES.PANDA_EIGHT]: 25,
  [BET_TYPES.DRAGON_SEVEN]: 40,
  [BANKER_WINS_WITH_SEVEN]: 0,
} as const;
